import { motion } from "framer-motion";
import { CornerDownRight, ChevronsRight } from "lucide-react";
import about_bg from "../../assets/images/about_banner.png";
import { Link } from "react-router-dom";
export default function AboutBanner() {
  return (
    <>
      
      <section className="relative w-full bg-[#f7f7f5] text-slate-900 overflow-hidden flex items-end pt-36 pb-16 md:pt-44 md:pb-28 select-none">
        <div
          className="pointer-events-none absolute lg:top-16 md:bottom-10 top-20
       right-5 max-w-[80%] lg:max-w-[50%] h-auto opacity-35 select-none"
        >
          <img
            src={about_bg}
            alt=""
            className="w-full h-auto object-contain object-right-top"
          />
        </div>
        <div className="mx-auto max-w-7xl px-6 lg:px-12 relative z-10 w-full">
          <div className="max-w-3xl">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="text-balance text-4xl sm:text-6xl md:text-7xl font-semibold tracking-tight text-slate-950  "
            >
              About{" "}
              <span className="font-serif italic font-light text-slate-500">
                Us.
              </span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
              className="mt-6 text-lg sm:text-xl text-slate-600 max-w-2xl leading-relaxed" 
            >
              Our team, the values we uphold, and our Vision for innovation is
              most important to us.
            </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
              className="mt-6 text-base text-slate-500 flex flex-row gap-1 items-center leading-relaxed"
            >
              <Link to="/">Home</Link> <ChevronsRight size={20} /> About Us
            </motion.p>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.25 }}
              className="mt-7 pt-6 border-t border-slate-300/80 flex items-center gap-3 text-xs font-mono text-slate-500 tracking-widest uppercase"
            >
              <CornerDownRight size={14} className="text-slate-950" />
              <span>Scroll to explore leadership &amp; architecture</span>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
}
